import OrdersContainer from "./OrdersContainer";

export default OrdersContainer;
